import { useState } from 'react';

import { TabValue } from '@/types';
import { SingleTargetSelector } from '@/components/common/SingleTargetSelector';
import type { MinimalTarget } from '@/generated/model';

import type { RefuelsQueryResultProps } from '../../types/RefuelsQueryResultProps.types';
import type { RefuelDateSelectView } from '../../utils/refuelDateSelectView';
import { RefuelDateSelect } from '../refuel-date-select/RefuelDateSelect';
import { RefuelResultPanel } from '../refuel-result-panel/RefuelResultPanel';

type RefuelsMobileLayoutProps = RefuelsQueryResultProps & {
  tab: TabValue;
  selectedTarget: MinimalTarget | undefined;
  exportFileName: string;
  view: RefuelDateSelectView;
  onDatesSelect: (from: Date, to: Date) => void;
  onChooseNewDate: () => void;
  onChooseNewVehicle: () => void;
  onTargetSelect: (target: MinimalTarget) => void;
};

export function RefuelsMobileLayout({
  tab,
  selectedTarget,
  result,
  isFetching,
  exportFileName,
  view,
  onDatesSelect,
  onRetry,
  onChooseNewDate,
  onChooseNewVehicle,
  onTargetSelect,
}: RefuelsMobileLayoutProps) {
  const [searchText, setSearchText] = useState<string>();

  function handleTargetSelect(target: MinimalTarget | undefined) {
    if (!target) {
      return;
    }

    onTargetSelect(target);
  }

  switch (tab) {
    case TabValue.targetSelect:
      return (
        <SingleTargetSelector
          setSelectedTarget={handleTargetSelect}
          selectedTarget={selectedTarget}
          searchText={searchText}
          setSearchText={setSearchText}
        />
      );
    case TabValue.dateSelect:
      return (
        <RefuelDateSelect
          view={view}
          isFetching={isFetching}
          onDatesSelect={onDatesSelect}
          onRetry={onRetry}
          onChooseNewDate={onChooseNewDate}
          onChooseNewVehicle={onChooseNewVehicle}
        />
      );
    case TabValue.result:
      return (
        <RefuelResultPanel
          // Remount on vehicle changes to reset RefuelDataGrid's local search text and grid state.
          key={selectedTarget?.id}
          result={result}
          isFetching={isFetching}
          isListView
          exportFileName={exportFileName}
        />
      );
    default:
      return tab satisfies never;
  }
}
